<script setup>
import { ref } from 'vue';
import Logo from "@/components/Logo.vue";
import { useAuthStore } from "../stores/auth";
import Button from '../components/Button.vue';

const auth = useAuthStore();

const email = ref()
const password = ref();

const error_text = ref('');

async function handleSubmit() {
  error_text.value = '';

  if (password.value) {
    try {
      const response = await auth.login(email.value, password.value);

    } catch (err) {
      error_text.value = err;
      throw new Error(err);
    }
  } else {
    error_text.value = 'Please enter a password'
    throw new Error('Please enter a password');
  }
}
</script>

<template>

  <div class="login">
    <img src="@img/login-bg.png" alt />
    <div class="login-form">
      <Logo></Logo>

      <div class="login__field">
        <label for="email">Email</label>
        <input type="email" v-model="email" required />
      </div>
      <div class="login__field">
        <label for="password">Password</label>
        <input type="password" v-model="password" required autocomplete="on" />
      </div>

      <div v-if="error_text != ''" class="error-display">
        <p>{{ error_text }}</p>
      </div>

      <Button :method="handleSubmit">Login</Button>

      <router-link class="forgot" :to="{ path: '/forgot-password' }">Forgot Password</router-link>
    </div>
  </div>

</template>

<style scoped>
.forgot {
  margin-top: 1rem;
  text-align: center;
  display: block;
  font-size: 0.8rem;
}

.error-display {
  max-width: fit-content;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid var(--orange);
  min-width: 100%;
}
</style>
